import { InboxFill, ExclamationOctagonFill, ArrowClockwise } from 'react-bootstrap-icons';
import './ui.css';

/**
 * The shared empty / error / loading placeholders. Having one component means
 * an empty market grid and an empty admin table look and behave the same.
 */

export const LoadingBlock = ({label, rows}) => (
    <div className="cx-state" role="status" aria-live="polite">
        <div className="cx-spinner" aria-hidden="true"></div>
        {label && <p className="cx-state-title">{label}</p>}
        {rows}
    </div>
);

export const EmptyBlock = ({title, message, action}) => (
    <div className="cx-state">
        <div className="cx-state-icon" aria-hidden="true"><InboxFill /></div>
        <p className="cx-state-title">{title}</p>
        {message && <p className="cx-state-message">{message}</p>}
        {action}
    </div>
);

export const ErrorBlock = ({title, message, retryLabel, onRetry}) => (
    <div className="cx-state" role="alert">
        <div className="cx-state-icon cx-state-icon-error" aria-hidden="true"><ExclamationOctagonFill /></div>
        <p className="cx-state-title">{title}</p>
        {message && <p className="cx-state-message">{message}</p>}
        {onRetry && (
            <button type="button" className="cx-btn cx-btn-primary" onClick={onRetry}>
                <ArrowClockwise /> {retryLabel}
            </button>
        )}
    </div>
);

/** Grey card outlines shown while the first page of results is loading. */
export const CardSkeletons = ({count = 6, className = ""}) => (
    <>
        {Array.from({length: count}).map((_, index) => (
            <div className={className} key={`skeleton-${index}`}>
                <div className="cx-skeleton-card">
                    <div className="cx-skeleton cx-skeleton-image"></div>
                    <div className="cx-skeleton-body">
                        <div className="cx-skeleton cx-skeleton-line cx-skeleton-line-lg"></div>
                        <div className="cx-skeleton cx-skeleton-line"></div>
                        <div className="cx-skeleton cx-skeleton-line cx-skeleton-line-sm"></div>
                    </div>
                </div>
            </div>
        ))}
    </>
);
